// GENERATE BY SVGR, DON NOT EDIT IT MANUALLY
import React from 'react';
interface SvgCompProps {
    className?: string;
    style?: React.CSSProperties;
    onClick?: React.MouseEventHandler<SVGSVGElement>;
}
const SvgExit = (props: SvgCompProps, ref: React.Ref<SVGSVGElement>) => {
    const svgProps = {
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': true,
        focusable: false,
        ...props
    };
    return (
        <svg viewBox="0 0 16 16" {...svgProps} ref={ref}>
            <path
                d="M11.875 1.7h-7.75c-1.35 0-2.45 1.1-2.45 2.45v7.725c0 1.35 1.1 2.45 2.45 2.45h7.725c1.35 0 2.45-1.1 2.45-2.45v-1.3a.62.62 0 0 0-.625-.625.62.62 0 0 0-.625.625v1.3a1.2 1.2 0 0 1-1.2 1.2H4.125a1.2 1.2 0 0 1-1.2-1.2v-7.75c0-.65.525-1.2 1.2-1.2h7.725c.65 0 1.2.525 1.2 1.2V5.15c0 .35.275.625.625.625s.625-.275.625-.625V4.125C14.3 2.8 13.2 1.7 11.875 1.7M3.825 8c0-.35.275-.625.625-.625h6.475L9.7 6.15c-.25-.25-.25-.65 0-.875.25-.25.65-.25.875 0L12.85 7.55c.1.1.175.2.2.35V8c0 .15-.05.325-.175.45l-2.3 2.3a.6.6 0 0 1-.45.175.64.64 0 0 1-.45-.175c-.25-.25-.25-.65 0-.875L10.9 8.65H4.45A.657.657 0 0 1 3.825 8"
                clipRule="evenodd"
            />
        </svg>
    );
};
SvgExit.displayName = 'SvgExit';
export default React.memo(React.forwardRef(SvgExit));
